// src/components/CaseCard.jsx
import { Link } from 'react-router-dom';
import { priorityConfig } from './PriorityBadge.jsx';

const STATUS_LABEL = {
  draft: 'Draft', new: 'New', ai_triage: 'AI Triage', assigned: 'Assigned',
  active: 'Active', escalated: 'Escalated', follow_up: 'Follow-up',
  resolved: 'Resolved', closed: 'Closed', archived: 'Archived',
};

function timeAgo(iso) {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default function CaseCard({ c }) {
  const edge = priorityConfig(c.priority).edge;
  return (
    <Link
      to={`/cases/${c.id}`}
      className="group flex items-stretch gap-4 rounded-lg border border-ink/10 bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden"
    >
      <div className={`w-1.5 shrink-0 ${edge} ${c.priority === 1 ? 'animate-p1-pulse' : ''}`} />
      <div className="flex-1 py-3 pr-4 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="font-mono text-sm text-ink/70">{c.case_ref}</span>
          <span className="text-xs text-ink/50">{timeAgo(c.updated_at)}</span>
        </div>
        <div className="mt-1 flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-charcoal">{STATUS_LABEL[c.status] ?? c.status}</span>
          {c.category && <span className="text-xs text-ink/50">· {c.category.replace('_', ' ')}</span>}
        </div>
        <div className="mt-1.5 flex items-center justify-between">
          <span className="text-xs text-ink/60">
            {c.assigned_staff_name ? `Assigned to ${c.assigned_staff_name}` : 'Unassigned'}
          </span>
          {c.channel === 'ussd' && <span className="text-xs rounded bg-accent-100 text-accent-600 px-1.5 py-0.5">USSD</span>}
        </div>
      </div>
    </Link>
  );
}
